import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import { MoreVert, Search } from "@material-ui/icons";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import moment from "moment";
import React from "react";
import {
  Accordion,
  Button,
  Col,
  Dropdown,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { connect } from "react-redux";
import { getBuyerTasksAction } from "./../../../actions/BuyerTransactionActions";
import {
  deleteTaskAction,
  getAllTasksAction,
  getTaskDetailsAction,
} from "./../../../actions/TransactionActions";
import { getVendorTasksAction } from "./../../../actions/VendorTransactionActions";
import noRecord from "./../../../assets/img/no-record.png";
import TaskAdd from "./task-add";
import TaskDetail from "./task-detail";
import {
  cryptoTokenDecode,
  getTimeFromMins,
  toastMessage,
} from "./../../Common/Common";
import DeletePrompt from "./../../Common/DeletePrompt";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import { getallpermissions } from "../../../actions/UserActions";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

var _ = require("lodash");

class TransactionTask extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.deleteTask = this.deleteTask.bind(this);
    let currentType = cryptoTokenDecode().roleName;
    let userType = cryptoTokenDecode().usertype;
    this.state = {
      addTask: "",
      editTask: "",
      show: false,
      OpenTaskDetail: false,
      OpenTaskAdd: false,
      home: true,
      radon: false,
      hoa: false,
      tasks: [],
      originalTasks: [],
      filteredTasks: [],
      searchedTasks: [],
      permissionArray: [],
      taskData: {},
      taskId: "",
      activeAccordion: [],
      taskFilter: (
        <>
          <span className="status-mark status-mark-grey" />
          All Tasks
        </>
      ),
      openTask: "",
      showLoader: false,
      searchParam: "",
      filterParam: "all",
      userRole: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      deleteId: "",
      deleteTaskModal: false,
      defaultFilterStatus: ["scheduled", "overdue"],
      selectedFilterStatus: ["scheduled", "overdue"],
      overdueChecked: true,
      scheduledChecked: true,
      completedChecked: false,
    };
    this.style = {
      chips: {
        fontSize: "0.875em",
        background: "transparent",
      },
      searchBox: {
        background: "transparent",
      },
      multiselectContainer: {
        fontSize: "0.875em",
        background: "transparent",
      },
    };
    this.multiselectRef = React.createRef();
  }

  // show add task row
  addTask = (i) => {
    if (window.innerWidth > 991) {
      this.setState({ editTask: "", addTask: "open", taskId: "" });
    } else {
      this.setState({ OpenTaskAdd: !this.state.OpenTaskAdd });
    }
  };

  // show task detail
  editTask(id) {
    this.setState({ taskId: id, editTask: "" }, () => {
      if (window.innerWidth > 991) {
        this.setState({ editTask: "open", addTask: "" });
      } else {
        this.setState({ OpenTaskDetail: !this.state.OpenTaskDetail });
      }
    });
  }

  // open task accordion
  setOpen(i) {
    if (i == 1) {
      this.setState({ home: !this.state.home });
    }
    if (i == 2) {
      this.setState({ radon: !this.state.radon });
    }
    if (i == 3) {
      this.setState({ hoa: !this.state.hoa });
    }
  }

  /**
   * @desc format tasks - group by contigency name or general - sort by event date time
   */
  formatTasks(unFormatedTasks) {
    var tasks = _.groupBy(unFormatedTasks, (e) => {
      return e.contingency || "General";
    });
    var newTasks = [];
    var activeAccordion = [];
    Object.keys(tasks).forEach((key) => {
      var data = { name: key, data: tasks[key], open: false };
      newTasks.push(data);
      activeAccordion.push(true);
    });
    newTasks.forEach((e) => {
      e.data = _.sortBy(e.data, "eventStartDate");
    });
    newTasks.sort((a, b) => {
      return b.name == "General" ? 1 : -1;
    });
    this.setState({ activeAccordion });
    return newTasks;
  }

  componentWillReceiveProps(nextProps) {
    if (!!nextProps.taskId) {
      this.editTask(nextProps.taskId);
    }
  }

  componentWillMount() {
    this.getAllTasks();
    this.props.rerenderParentCallback();
    if (this.props.history.location.taskId != undefined) {
      this.editTask(this.props.history.location.taskId);
    }
  }

  componentDidMount() {
    // this.changeTaskFilter();
    this.getUserPermissions();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.tasks !== this.state.tasks) {
  //     this.changeTaskFilter();
  //   }
  // }

  /**
   * @desc get all tasks based on user type
   * @param {*} type
   */
  getAllTasks(type) {
    this.setState({ showLoader: true, addTask: "" });

    if (
      this.state.userRole === message.VENDOR &&
      this.state.currentRole === message.Artist
    ) {
      if (type == "delete") {
        if (window.innerWidth > 991) {
          this.setState({ editTask: "", addTask: "" });
        } else {
          this.setState({ OpenTaskDetail: false });
        }
        // this.props
        //   .getVendorTasksAction(this.props.transactionId)
        //   .then((res) => {
        //     this.setState(
        //       {
        //         tasks: this.formatTasks(this.props.vendorTasks.data),
        //         originalTasks: this.props.vendorTasks.data,
        //         filteredTasks: this.props.vendorTasks.data,
        //         showLoader: false,
        //       },
        //       () => {
        //         this.changeTaskFilter();
        //       }
        //     );
        //   });
        this.props.getAllTasksAction(this.props.transactionId).then((res) => {
          this.setState(
            {
              tasks: this.formatTasks(this.props.tasks.data),
              originalTasks: this.props.tasks.data,
              filteredTasks: this.props.tasks.data,
              showLoader: false,
            },
            () => {
              this.changeTaskFilter();
            }
          );
        });
      } else {
        // this.props
        //   .getVendorTasksAction(this.props.transactionId)
        //   .then((res) => {
        //     this.setState(
        //       {
        //         tasks: this.formatTasks(
        //           this.props.vendorTasks != null &&
        //             this.props.vendorTasks != undefined
        //             ? this.props.vendorTasks.data
        //             : []
        //         ),
        //         originalTasks:
        //           this.props.vendorTasks != null &&
        //           this.props.vendorTasks != undefined
        //             ? this.props.vendorTasks.data
        //             : [],
        //         filteredTasks:
        //           this.props.vendorTasks != null &&
        //           this.props.vendorTasks != undefined
        //             ? this.props.vendorTasks.data
        //             : [],
        //         showLoader: false,
        //       },
        //       () => {
        //         this.changeTaskFilter();
        //       }
        //     );
        //   });
        this.props.getAllTasksAction(this.props.transactionId).then((res) => {
          this.setState(
            {
              tasks: this.formatTasks(this.props.tasks.data),
              originalTasks: this.props.tasks.data,
              filteredTasks: this.props.tasks.data,
              showLoader: false,
            },
            () => {
              this.changeTaskFilter();
            }
          );
        });
      }
    } else if (
      this.state.userRole === message.VENDOR ||
      this.state.currentRole === message.BUYER
    ) {
      this.props.getBuyerTasksAction(this.props.transactionId).then((res) => {
        this.setState(
          {
            tasks: this.formatTasks(this.props.buyerTasks.data),
            originalTasks: this.props.buyerTasks.data,
            filteredTasks: this.props.buyerTasks.data,
            showLoader: false,
          },
          () => {
            this.changeTaskFilter();
          }
        );
      });
    } else {
      if (type == "delete") {
        if (window.innerWidth > 991) {
          this.setState({ editTask: "", addTask: "" });
        } else {
          this.setState({ OpenTaskDetail: false });
        }
        this.props.getAllTasksAction(this.props.transactionId).then((res) => {
          this.setState(
            {
              tasks: this.formatTasks(this.props.tasks.data),
              originalTasks: this.props.tasks.data,
              filteredTasks: this.props.tasks.data,
              showLoader: false,
            },
            () => {
              this.changeTaskFilter();
            }
          );
        });
      } else {
        this.props.getAllTasksAction(this.props.transactionId).then((res) => {
          this.setState(
            {
              tasks: this.formatTasks(this.props.tasks.data),
              originalTasks: this.props.tasks.data,
              filteredTasks: this.props.tasks.data,
              showLoader: false,
            },
            () => {
              this.changeTaskFilter();
            }
          );
        });
      }
    }
  }

  toggleAccordion(i) {
    var activeAccordion = this.state.activeAccordion;
    activeAccordion[i] = activeAccordion[i] == true ? false : true;
    this.setState({
      activeAccordion,
    });
  }

  /**
   * @desc tasks render with accordion
   * @param {*} tasks
   * @param {*} name
   */
  renderCollapse(tasks, name) {
    return (
      <Accordion.Collapse eventKey={name}>
        {/* Loop though tasks */}
        <div>
          {tasks.map((task, i) => {
            return (
              <Row
                key={"ts" + i}
                className={
                  this.state.taskId == task._id
                    ? "mx-0 align-items-center task-row active"
                    : "mx-0 align-items-center task-row"
                }
              >
                <Col className="col-auto task-status-col">
                  {task.overDue ? (
                    <span className={"task-status task-status-orange"} />
                  ) : (
                    <>
                      {task.status == "SCHEDULED" && (
                        <span className={"task-status task-status-blue"} />
                      )}
                      {task.status == "COMPLETED" && (
                        <span className={"task-status task-status-green"} />
                      )}
                    </>
                  )}
                </Col>
                <Col
                  className="task-name-col"
                  onClick={() => this.editTask(task._id)}
                >
                  <div className="task-name">{task.title}</div>
                  <div className="task-date">
                    <em>
                      {moment(task.eventStartDate).format("MM/DD/YYYY hh:mm a")}
                    </em>
                  </div>
                </Col>

                {this.state.currentRole === message.BUYER ? (
                  ""
                ) : (
                  <Col className="col-auto px-0 task-action-col">
                    <Dropdown alignRight className="task-action">
                      <Dropdown.Toggle
                        variant="transparent"
                        id="dropdown-basic"
                        className="p-0"
                      >
                        <MoreVert />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            // if (localStorage.getItem("isActive") === "false") {
                            //     toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                            // } else {
                            //     this.deleteModal(task._id)
                            // }

                            this.deleteModal(task._id);
                          }}
                        >
                          Delete task
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                )}
              </Row>
            );
          })}
        </div>
      </Accordion.Collapse>
    );
  }

  taskFilterByStatus = (e) => {
    let index;
    let options = this.state.selectedFilterStatus;
    if (e.target.checked) {
      options.push(e.target.name);
    } else {
      index = options.indexOf(e.target.name);
      options.splice(index, 1);
    }
    this.setState({ selectedFilterStatus: options }, () => {
      this.changeTaskFilter();
    });
  };

  /**
   * @desc change task filter action - filter task based on selected status
   */
  changeTaskFilter() {
    let param = this.state.selectedFilterStatus;
    var tasks = this.state.originalTasks;
    // console.log("438-tasks", tasks);
    // console.log("438-param", param);
    tasks =
      tasks &&
      tasks.filter((task) => {
        const typeMatch =
          param.length > 0
            ? param.filter((e) => {
                if (e === "scheduled") {
                  task.eventStartDate = new Date(
                    moment(task.eventStartDate).format("MM/DD/YYYY ") +
                      getTimeFromMins(task.time)
                  );
                  return (
                    task.status.toLowerCase() == e &&
                    moment(task.eventStartDate) > moment()
                  );
                }
                if (e === "overdue") {
                  task.eventStartDate = new Date(
                    moment(task.eventStartDate).format("MM/DD/YYYY ") +
                      getTimeFromMins(task.time)
                  );
                  return (
                    this.props.transactionData.status === "INPROGRESS" &&
                    moment(task.eventStartDate) < moment() &&
                    task.status !== "COMPLETED"
                  );
                }
                if (e === "completed") {
                  return (task.status + "").toLowerCase() == e;
                }
                if (e === "all") {
                  return (tasks = this.state.originalTasks);
                }
              }).length > 0
            : true;
        return typeMatch;
      });
    // console.log("tasks-477", tasks);
    this.setState({ tasks: this.formatTasks(tasks), filteredTasks: tasks });
  }

  /**
   * @desc search task - apply filter of status first if there then search title of task
   * @param {*} param
   */
  searchTasks(param) {
    var tasks = this.state.originalTasks;
    var filteredTasks = [];
    if (param) {
      if (this.state.selectedFilterStatus.includes("scheduled")) {
        let scheduleTask = [];
        scheduleTask = tasks.filter((e) => {
          return e.status.toLowerCase() == "scheduled" && e.overDue == false;
        });
        if (scheduleTask.length > 0) {
          filteredTasks.push(...scheduleTask);
        }
      }
      if (this.state.selectedFilterStatus.includes("overdue")) {
        let overdueTask = [];
        overdueTask = tasks.filter((e) => {
          e.eventStartDate = new Date(
            moment(e.eventStartDate).format("MM/DD/YYYY ") +
              getTimeFromMins(e.time)
          );
          return (
            this.props.transactionData.status === "INPROGRESS" &&
            moment(e.eventStartDate) < moment() &&
            e.status !== "COMPLETED"
          );
        });
        if (overdueTask.length > 0) {
          filteredTasks.push(...overdueTask);
        }
      }
      if (this.state.selectedFilterStatus.includes("completed")) {
        let completedTask = [];
        completedTask = tasks.filter((e) => {
          return (e.status + "").toLowerCase() == "completed";
        });
        if (completedTask.length > 0) {
          filteredTasks.push(...completedTask);
        }
      }
      if (!this.state.selectedFilterStatus.length) {
        filteredTasks = this.state.originalTasks;
      }
      tasks = filteredTasks.filter((e) => {
        return e.title.toLowerCase().includes(param.trim().toLowerCase());
      });
      this.setState({
        searchParam: param,
        tasks: this.formatTasks(tasks),
        searchedTasks: tasks,
      });
    } else {
      this.changeTaskFilter();
    }
  }

  deleteTask(id) {
    this.setState({ deleteTaskModal: false });
    this.props.deleteTaskAction(id).then((res) => {
      this.getAllTasks("delete");
    });
  }

  deleteModal(id) {
    this.setState({ deleteId: id, deleteTaskModal: true });
  }

  updateTasks(name) {
    this.setState({ OpenTaskAdd: false });
    if (name == "update") {
      this.getAllTasks();
    } else {
      this.setState({ addTask: "", editTask: "", taskId: "" });
    }
  }

  /**
   * @desc check task status and set color according status
   */
  getStatusColor(t) {
    t.eventStartDate = new Date(
      moment(t.eventStartDate).format("MM/DD/YYYY ") + getTimeFromMins(t.time)
    );
    var color = "blue";
    if (t.status == "SCHEDULED") {
      color = "blue";
      if (
        this.props.transactionData.status === "INPROGRESS" &&
        moment(t.eventStartDate) < moment()
      ) {
        color = "orange";
      }
    } else if (t.status == "COMPLETED") {
      color = "green";
    }
    return color;
  }

  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    if (usertype === "VENDOR") {
      this.props.getallpermissions().then((res) => {
        if (res.data) {
          localStorage.setItem("otherInfo", res.data);
          this.setState({ permission: res.data });
          let bytes = CryptoJS.AES.decrypt(
            res.data,
            REACT_APP_CRYPTO_SECRET_KEY
          );
          let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          // console.log("Header ===> decryptedData39", decryptedData);
          let permissionarray = decryptedData.split(",");
          // console.log("Header ===> permissionarray", permissionarray);
          this.setState({ permissionArray: permissionarray });
        }
      });
    }
  }

  checkPermission(checkFor) {
    const hasSome =
      this.state.permissionArray &&
      this.state.permissionArray.length > 0 &&
      checkFor.some((item) => this.state.permissionArray.includes(item));
    return hasSome;
  }

  render() {
    // console.log("tasks-603", this.state.tasks);
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="task-page">
              {/* {(this.state.userRole === message.VENDOR &&
                !this.checkPermission([message.manage_transactions])) ||
              this.props.transactionData.status == "COMPLETED" ||
              this.state.userRole === message.BUYER ||
              this.props.transactionData.status == "CANCELED" ? ( */}
              {this.state.userRole === message.ADMIN ||
              this.props.transactionData.status == "COMPLETED" ||
              this.state.currentRole === message.BUYER ||
              this.props.transactionData.status == "CANCELED" ? (
                ""
              ) : (
                <Row className="mx-0 px-0 page-head-row page-head-row-inner align-items-center mt-10">
                  <Col>
                    <Button
                      variant="primary"
                      className="btn-blue btn-head"
                      onClick={() => {
                        // if (localStorage.getItem("isActive") === "false") {
                        //     toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                        // } else { this.addTask() }
                        this.addTask();
                      }}
                    >
                      {" "}
                      + Add Task
                    </Button>
                  </Col>
                </Row>
              )}
              <div
                className={
                  this.state.userRole === message.VENDOR ||
                  this.state.userRole === message.BUYER ||
                  this.props.transactionData.status == "COMPLETED"
                    ? "task-block task-block-vendor"
                    : "task-block"
                }
              >
                <Row className="mx-0">
                  <Col className="px-0">
                    <Row className="mx-0 py-1 align-items-center page-head-row-small task-search">
                      <Col>
                        <div className="icon-wrapper">
                          <Form.Control
                            type="text"
                            className="form-control-head"
                            placeholder="Search by Name"
                            onChange={(e) => {
                              this.searchTasks(e.target.value);
                            }}
                          />
                          <span className="form-control-icn">
                            <Search />
                          </span>
                        </div>
                      </Col>
                      <Col className="col-auto" align="right">
                        <div className="select-multi custom-multi-select">
                          <div className="task-value">
                            <input
                              type="checkbox"
                              id="scheduled"
                              name="scheduled"
                              value="scheduled"
                              onChange={(e) => {
                                this.setState({
                                  scheduledChecked: !this.state
                                    .scheduledChecked,
                                });
                                this.taskFilterByStatus(e);
                              }}
                              checked={this.state.scheduledChecked}
                            />
                            <label for="scheduled" className="blue">
                              {" "}
                              Scheduled Tasks
                            </label>
                          </div>
                          <div className="task-value">
                            <input
                              type="checkbox"
                              id="overdue"
                              name="overdue"
                              value="overdue"
                              onChange={(e) => {
                                this.setState({
                                  overdueChecked: !this.state.overdueChecked,
                                });
                                this.taskFilterByStatus(e);
                              }}
                              checked={this.state.overdueChecked}
                            />
                            <label for="overdue" className="orange">
                              {" "}
                              Overdue Tasks
                            </label>
                          </div>
                          <div className="task-value">
                            <input
                              type="checkbox"
                              id="completed"
                              name="completed"
                              value="completed"
                              onChange={(e) => {
                                this.setState({
                                  completedChecked: !this.state
                                    .completedChecked,
                                });
                                this.taskFilterByStatus(e);
                              }}
                              checked={this.state.completedChecked}
                            />
                            <label for="completed" className="green">
                              {" "}
                              Completed Tasks
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="task-content">
                      {this.state.tasks.length <= 0 &&
                        this.state.addTask == "" && (
                          <div className="no-transaction no-record">
                            <div className="no-transaction-inner">
                              <img src={noRecord} alt="no record" />
                              <p>No task found</p>
                            </div>
                          </div>
                        )}

                      {this.state.userRole === message.VENDOR ||
                      this.state.userRole === message.BUYER ? (
                        <>
                          {this.state.tasks.length > 0 &&
                            this.state.tasks.map((t, i) => {
                              return (
                                <div className="task-row-group">
                                  {t.data.map((task, i) => {
                                    return (
                                      <Row
                                        key={"ts" + i}
                                        className={
                                          this.state.taskId == task._id
                                            ? "mx-0 align-items-center task-row active"
                                            : "mx-0 align-items-center task-row"
                                        }
                                      >
                                        <Col className="col-auto task-status-col">
                                          <span
                                            className={
                                              "task-status task-status-" +
                                              this.getStatusColor(task)
                                            }
                                          />
                                        </Col>

                                        <Col
                                          className="task-name-col"
                                          onClick={() =>
                                            this.editTask(task._id)
                                          }
                                        >
                                          <div className="task-name">
                                            {task.title}
                                          </div>
                                          <div className="task-date">
                                            <em>
                                              {moment(
                                                task.eventStartDate
                                              ).format("MM/DD/YYYY ") +
                                                getTimeFromMins(task.time)}
                                            </em>
                                          </div>
                                        </Col>

                                        {this.state.currentRole ===
                                        message.BUYER ? (
                                          ""
                                        ) : (
                                          <Col className="col-auto px-0 task-action-col">
                                            <Dropdown
                                              alignRight
                                              className="task-action"
                                            >
                                              <Dropdown.Toggle
                                                variant="transparent"
                                                id="dropdown-basic"
                                                className="p-0"
                                              >
                                                <MoreVert />
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu>
                                                {this.state.currentRole ===
                                                message.BUYER ? (
                                                  ""
                                                ) : (
                                                  <Dropdown.Item
                                                    onClick={() => {
                                                      //   if (
                                                      //     localStorage.getItem(
                                                      //       "isActive"
                                                      //     ) === "false"
                                                      //   ) {
                                                      //     toastMessage(
                                                      //       code.ERROR,
                                                      //       message.SUBSCRIPTION_NOT_ACTIVE
                                                      //     );
                                                      //   } else {
                                                      //     this.deleteModal(
                                                      //       task._id
                                                      //     );
                                                      //   }
                                                      this.deleteModal(
                                                        task._id
                                                      );
                                                    }}
                                                  >
                                                    Delete task
                                                  </Dropdown.Item>
                                                )}
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                        )}
                                      </Row>
                                    );
                                  })}
                                </div>
                              );
                            })}
                        </>
                      ) : (
                        <>
                          {this.state.tasks.map((t, i) => {
                            return (
                              <ExpansionPanel
                                key={t.name + i}
                                defaultExpanded={true}
                                className="task-combo"
                              >
                                <ExpansionPanelSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  className="task-row task-accordion card-header"
                                  id="panel1a-header"
                                >
                                  <span />
                                  {t.name}
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails className="task-row-detail">
                                  <div className="task-row-group">
                                    {t.data.map((task, i) => {
                                      return (
                                        <Row
                                          key={"ts" + i}
                                          className={
                                            this.state.taskId == task._id
                                              ? "mx-0 align-items-center task-row active"
                                              : "mx-0 align-items-center task-row"
                                          }
                                        >
                                          {/* active */}
                                          <Col className="col-auto task-status-col">
                                            <span
                                              className={
                                                "task-status task-status-" +
                                                this.getStatusColor(task)
                                              }
                                            />
                                          </Col>

                                          <Col
                                            className="task-name-col"
                                            onClick={() =>
                                              this.editTask(task._id)
                                            }
                                          >
                                            <div className="task-name">
                                              {task.title}
                                            </div>
                                            <div className="task-date">
                                              <em>
                                                {moment(
                                                  task.eventStartDate
                                                ).format("MM/DD/YYYY ") +
                                                  getTimeFromMins(task.time)}
                                              </em>
                                            </div>
                                          </Col>
                                          {this.state.currentRole ===
                                          message.BUYER ? (
                                            ""
                                          ) : (
                                            <Col className="col-auto px-0 task-action-col">
                                              <Dropdown
                                                alignRight
                                                className="task-action"
                                              >
                                                <Dropdown.Toggle
                                                  variant="transparent"
                                                  id="dropdown-basic"
                                                  className="p-0"
                                                >
                                                  <MoreVert />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                  {this.state.currentRole ===
                                                  message.BUYER ? (
                                                    ""
                                                  ) : (
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        // if (
                                                        //   localStorage.getItem(
                                                        //     "isActive"
                                                        //   ) === "false"
                                                        // ) {
                                                        //   toastMessage(
                                                        //     code.ERROR,
                                                        //     message.SUBSCRIPTION_NOT_ACTIVE
                                                        //   );
                                                        // } else {
                                                        //   this.deleteModal(
                                                        //     task._id
                                                        //   );
                                                        // }
                                                        this.deleteModal(
                                                          task._id
                                                        );
                                                      }}
                                                    >
                                                      Delete task
                                                    </Dropdown.Item>
                                                  )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                          )}
                                        </Row>
                                      );
                                    })}
                                  </div>
                                </ExpansionPanelDetails>
                              </ExpansionPanel>
                            );
                          })}
                        </>
                      )}
                    </div>
                  </Col>
                  <Col className="px-0 col-auto">
                    <div
                      className={
                        this.state.editTask + " task-single calendar-add-task"
                      }
                    >
                      {this.state.editTask == "open" && (
                        <TaskDetail
                          taskId={this.state.taskId}
                          transactionData={this.props.transactionData}
                          deleteTask={(id) => {
                            this.deleteModal(id);
                          }}
                          onUpdate={(e) => this.updateTasks(e)}
                          permissiontype={message.manage_transactions}
                        />
                      )}
                    </div>

                    <div
                      className={
                        this.state.addTask + " task-single calendar-add-task"
                      }
                    >
                      {this.state.addTask == "open" && (
                        <TaskAdd
                          onUpdate={(e) => this.updateTasks(e)}
                          taskId={this.state.taskId}
                          transactionData={this.props.transactionData}
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Task Detail in Mobile */}
                <Modal
                  show={this.state.OpenTaskDetail}
                  onHide={() => this.editTask()}
                  dialogClassName="modal-90w"
                  aria-labelledby="example-custom-modal-styling-title"
                  className="modal-med modal-view-page task-mobile-modal"
                >
                  <Modal.Header closeButton />
                  <Modal.Body>
                    <TaskDetail
                      taskId={this.state.taskId}
                      transactionData={this.props.transactionData}
                      deleteTask={(id) => {
                        this.deleteModal(id);
                      }}
                      onUpdate={(e) => this.updateTasks(e)}
                      permissiontype={message.manage_transactions}
                    />
                  </Modal.Body>
                </Modal>

                {/* Task Add in Mobile */}
                <Modal
                  show={this.state.OpenTaskAdd}
                  onHide={() => this.addTask()}
                  dialogClassName="modal-90w"
                  aria-labelledby="example-custom-modal-styling-title"
                  className="modal-med modal-view-page task-mobile-modal"
                >
                  <Modal.Header closeButton />
                  <Modal.Body>
                    <TaskAdd
                      onUpdate={(e) => this.updateTasks(e)}
                      taskId={this.state.taskId}
                      transactionData={this.props.transactionData}
                    />
                  </Modal.Body>
                </Modal>

                {/* Delete Task Modal */}
                <DeletePrompt
                  deletePrompt={this.state.deleteTaskModal}
                  itemId={this.state.deleteId}
                  cancel={() => {
                    this.setState({ deleteTaskModal: false });
                  }}
                  deleteConfirm={this.deleteTask}
                />
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tasks: state.reducer.tasks,
    vendorTasks: state.reducer.vendorTasks,
    buyerTasks: state.reducer.buyerTasks,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllTasksAction,
    getTaskDetailsAction,
    deleteTaskAction,
    getVendorTasksAction,
    getBuyerTasksAction,
    getallpermissions,
  }
)(TransactionTask);
